<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import 'animate.css';
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import "./assets/common.scss";
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  overflow: hidden;

}
body,html{
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue